<template>
  <v-form ref="extForm">
    <v-row align="center" justify="center">
      <h3><b>{{ $t('json.extensionsett') }}</b></h3>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-label>{{ $t('json.extensionsettinfo') }}</v-label><br/>
        <v-chip v-for="ext in props.General.AllowedExtensions" :key="ext" :color="(ext.toUpperCase() === extension.toUpperCase()) ? 'red' : 'primary'" class="ma-2" label close @click:close="removeExtension(ext)">{{ ext.toUpperCase() }}</v-chip>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="extension" :rules="rules.extensionName" :label="$t('json.extensioninput')"></v-text-field>
        <v-btn @click="addExtension">{{ $t('json.extensionadd') }}</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>

export default {
  name: 'ExtensionSettings',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      extension: '',
      rules: {
        extensionName: [
          (v) => !!v || this.$i18n.t('json.ruleempty'),
          (v) => this.checkExtension(v) || ''
        ]
      }
    }
  },
  methods: {
    checkExtension (v) {
      const found = this.props.General.AllowedExtensions.find(ext => v.toLowerCase() === ext)
      if (found) return false
      return true
    },
    async removeExtension (ext) {
      const index = this.props.General.AllowedExtensions.indexOf(ext)
      this.props.General.AllowedExtensions.splice(index, 1)
      // this.$emit('changeSettings')
      this.$emit('changeExtensionSettings', this.props.General.AllowedExtensions)
    },
    async addExtension () {
      if (this.$refs.extForm.validate()) {
        const ext = this.extension.toLowerCase()
        const valid = this.checkExtension(ext)
        if (!valid) return
        this.props.General.AllowedExtensions.push(ext)
        this.extension = ''
        // this.$emit('changeSettings')
        this.$emit('changeExtensionSettings', this.props.General.AllowedExtensions)
      }
    }
  }
}
</script>
